import { MenuItem } from '@mui/material';
import clsx from 'clsx';
import styles from './ActionMenuItem.module.scss';

const ActionMenuItem = ({ icon, text, onClick, isDelete, iconWidth, iconHeight }) => (
  <MenuItem className={styles.menuItemWrapper} onClick={onClick}>
    <>
      {icon && (
        <div className={styles.iconWrapper}>
          <img src={icon} alt="" style={{ width: iconWidth, height: iconHeight }} />
        </div>
      )}
      <div className={clsx(styles.text, isDelete ? styles.delete : '')}>{text}</div>
    </>
  </MenuItem>
);

export default ActionMenuItem;
